export const READ_CREDIT_ORDER='READ_CREDIT_ORDER';
export const ADJUST_PAYMENT='ADJUST_PAYMENT';
export const DEPOSIT_CALLBACK='DEPOSIT_CALLBACK';
export const READ_PAY_ORDER='READ_PAY_ORDER';
export const OPERATION_PAYFOR_RETRY_NOTIFY='OPERATION_PAYFOR_RETRY_NOTIFY';
export const OPERATION_PAYFOR_SPEEDUP='OPERATION_PAYFOR_SPEEDUP';
export const READ_COLLECT_ORDER='READ_COLLECT_ORDER';
export const READ_WITHDRAW_ORDER='READ_WITHDRAW_ORDER';
export const OPERATION_WITHDRAW_SPEEDUP='OPERATION_WITHDRAW_SPEEDUP';
export const PROFIT_WITHDRAW_MANAGER = 'PROFIT_WITHDRAW_MANAGER';